// extracted by mini-css-extract-plugin
export default {"heading":"SearchFilter_heading__w8kG5"};